import { atom } from "jotai"

export const INIT_ORG = {
    orgId: null,
    orgName: "",
    orgAddress: "",
    orgContactPerson: "",
    orgContactNo: "",
    orgEfficiencyFactor: null,
    status: "true", 
}

export const organizationAtom  = atom(INIT_ORG)
